import React from "react";
import './App.css';
import Website from "./components/Site";



function App(){
    return < Website />;
}
    

export default App;
